import { createSelector } from '@ngrx/store';

import {
  CurrentUserState,
  CURRENT_USER_INITIAL_STATE,
} from '®shared/current-user/current-user.state';
import {
  getActiveTimePeriods,
  getBookstores,
  getCitationStyles,
  getDefaultListAccess,
  getImportances,
  getLanguages,
  getLicenses,
  getTenant,
  TenantState,
  TENANT_INITIAL_STATE,
} from '®shared/tenant/tenant.state';

export interface State {
  currentUser: CurrentUserState;
  tenancy: TenantState;
}

export const INITIAL_STATE: State = {
  currentUser: CURRENT_USER_INITIAL_STATE,
  tenancy: TENANT_INITIAL_STATE,
};

export function getInitialState(): State {
  return INITIAL_STATE;
}

export const getCurrentUserState = (state: State): CurrentUserState =>
  state.currentUser;

export const getTenancyState = (state: State): TenantState => state.tenancy;

export const selectCurrentUser = createSelector(
  getCurrentUserState,
  user => user.loadableUser,
);

export const selectCurrentUserGuid = createSelector(
  getCurrentUserState,
  (userState: CurrentUserState) =>
    (userState &&
      userState.loadableUser &&
      userState.loadableUser.data &&
      userState.loadableUser.data.oauthUser &&
      userState.loadableUser.data.oauthUser.guid) ||
    null,
);

export const selectTenant = createSelector(
  getTenancyState,
  getTenant,
);

export const selectBookstores = createSelector(
  selectTenant,
  getBookstores,
);

export const selectCitationStyles = createSelector(
  selectTenant,
  getCitationStyles,
);

export const selectDefaultListAccess = createSelector(
  selectTenant,
  getDefaultListAccess,
);

export const selectImportances = createSelector(
  selectTenant,
  getImportances,
);

export const selectLanguages = createSelector(
  selectTenant,
  getLanguages,
);

export const selectLicenses = createSelector(
  selectTenant,
  getLicenses,
);

export const selectActiveTimePeriods = createSelector(
  selectTenant,
  getActiveTimePeriods,
);
